const filters = {
  essentials: {
    cmiNumber: { label: 'CMI #', key: 'c_mi_number', value: '', target: 'study' },
    paceNumber: { label: 'Pace #', key: 'pace_number', value: '', target: 'study' },
    client: { label: 'Client', key: 'client', value: '', target: 'study' },
    product: { label: 'Product', key: 'product_type', value: '', target: 'study' },
    businessUnit: { label: 'B.U.', key: 'product_area', value: '', target: 'study' },
    category: { label: 'Category', key: 'category', value: '', target: 'study' },
    startYear: { label: 'Start year', key: 'year', value: '', target: 'study' },
    endYear: { label: 'End year', key: 'year', value: '', target: 'study' },
    region: { label: 'Region', key: 'region', value: [], target: 'study' },
    country: { label: 'Country', key: 'country', value: '', target: 'study' },
    verified: { label: 'Verified', key: 'verified', value: true, target: 'study' }
  },
  fragranceDetails: {
    fragranceName: { label: 'Fragrance name', key: 'name', value: '', target: 'fragrance' },
    perfumerRefNumber: { label: 'Reference #', key: 'ref_number', value: '', target: 'fragrance' },
    perfumerName: { label: 'Perfumer name', key: 'perfumer_name', value: '', target: 'fragrance' },
    sapNumber: { label: 'SAP #', key: 'code', value: '', target: 'fragrance' },
    family: { label: 'Family', key: 'family', value: '', target: 'fragrance' },
    subfamily: { label: 'Subfamily', key: 'subfamily', value: '', target: 'fragrance' },
    specifier: { label: 'Specifier', key: 'specifier', value: '', target: 'fragrance' },
    methodology: { label: 'Methodology', key: 'methodology', value: '', target: 'fragrance' },
    region: { label: 'Region', key: 'region', value: [], target: 'fragrance' },
    country: { label: 'Country', key: 'country', value: '', target: 'fragrance' },
    creative: { label: 'Creative', key: 'creative', value: undefined, target: 'fragrance' }
  },
  conceptDetails: {
    name: { label: 'Concept name', key: 'name', value: '', target: 'concept' },
    theme: { label: 'Concept theme', key: 'theme', value: '', target: 'concept' },
    ingredient1: { label: 'Ingredient 1', key: 'ingredient_1', value: '', target: 'concept' },
    ingredient2: { label: 'Ingredient 2', key: 'ingredient_2', value: '', target: 'concept' },
    region: { label: 'Region', key: 'region', value: [], target: 'concept' },
    country: { label: 'Country', key: 'country', value: '', target: 'concept' }
  },
  methodology: {
    designMethod: { label: 'Design method', key: 'design_method', value: '', target: 'study' },
    researchType: { label: 'Research type', key: 'research_type', value: '', target: 'study' },
    cmiTool: { label: 'CMI tool', key: 'cmi_tool_type', value: '', target: 'study' },
    methodology: { label: 'Methodology', key: 'methodology', value: '', target: 'study' },
    objectiveAndStandards: { label: 'Obj. and standards', key: 'objective_and_action_standards', value: '', target: 'study' },
    panelProfile: { label: 'Panel profile', key: 'panel_profile', value: '', target: 'study' }
  },
  demographics: {
    /* bumo: { label: 'BUMO', key: 'bumo', value: '', target: 'study' },
    socialClass: { label: 'Social Class', key: 'social_class', value: '', target: 'study' }, */
    gender: { label: 'Gender', key: 'gender', value: '', target: 'study' },
    ethnicity: { label: 'Ethnicity', key: 'ethnicity', value: '', target: 'study' },
    startAge: { label: 'Lower age limit', key: 'age', value: '', target: 'study' },
    endAge: { label: 'Higher age limit', key: 'age', value: '', target: 'study' }
  },
  metrics: {
    stage: { label: 'Stage', key: 'stage', value: '' },
    order: { label: 'Order', key: 'order', value: '' },
    rdfType: { label: 'RDF type', key: 'rdf_type', value: 'rdf' },
    useConcepts: false,
    threshold: {
      applyThreshold: false,
      amount: 10,
      desc: true,
      type: ''
    },
    metricsList: [{
      applyThreshold: false,
      threshold: { label: 'Threshold on metrics', key: 'threshold', value: { amount: 10, desc: true, type: '' } },
      metricType: { label: 'Metric type', key: 'metric_type', value: '' },
      metric: { label: 'Metric', key: 'metric', value: '' },
      aggregation: { label: 'Aggregation', key: 'aggregation', value: '' },
      confidence: { label: 'Confidence', key: 'confidence', value: false }
    }]
  }
}

const cicsFilters = {
  geographicalType: { label: 'Geographical Type', key: 'geo_type', value: '' },
  geographicalValue: { label: 'Value', key: 'geo_value', value: '' },
  gender: { label: 'Gender', key: 'gender', value: '' },
  question: { label: 'Question', key: 'question', value: '' },
  startAge: { label: 'Lower age limit', key: 'age', value: '' },
  endAge: { label: 'Higher age limit', key: 'age', value: '' }
}

const getInitialFilters = () => {
  return filters
}

const getCicsFilters = () => {
  return cicsFilters
}

const getEmptyMetric = () => {
  return {
    applyThreshold: false,
    threshold: { label: 'Threshold on metrics', key: 'threshold', value: { amount: 10, desc: true, type: '' } },
    metricType: { label: 'Metric type', key: 'metric_type', value: '' },
    metric: { label: 'Metric', key: 'metric', value: '' },
    aggregation: { label: 'Aggregation', key: 'aggregation', value: '' }
  }
}

export default {
  getInitialFilters,
  getCicsFilters,
  getEmptyMetric
}
